import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import Button from '@/v2/components/common/Button'
import { usePatientContext } from '@/v2/contexts/PatientContext'
import NextAppointment from '../NextAppointment'
import NavigationTabs from '../NavigationTabs'
import { TabsAndButtonsWrapper, Wrapper } from './styles'

const PatientBar = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { patient } = usePatientContext()

  if (!patient || !patient.id) {
    return null
  }

  const handleMessagesClick = e => {
    e.preventDefault()
    if (patient.phoneNumber === null) {
      alert(
        "This patient doesn't have a phone number!\nPlease, update the patient contact info."
      )
    } else {
      navigate(`/v2/messages/start-conversation/${patient.id}`)
    }
  }

  return (
    <Wrapper theme={theme.palette}>
      <NextAppointment />
      <TabsAndButtonsWrapper theme={theme.palette}>
        <NavigationTabs />
        <Button
          className="patient-messages-button"
          variant="outlined"
          onClick={handleMessagesClick}
        >
          Messages
        </Button>
      </TabsAndButtonsWrapper>
    </Wrapper>
  )
}

export default PatientBar
